import { AthenaEvent } from "@evidenceb/athena-event-storage-schemas";

export interface RxdbAthenaEvent extends AthenaEvent<any, any> {
  _deleted: false;
}

export function fromAthenaEvent(
  athenaEvent: AthenaEvent<any, any>,
): RxdbAthenaEvent {
  return { ...athenaEvent, _deleted: false };
}

export function toAthenaEvent(
  rxdbAthenaEvent: RxdbAthenaEvent,
): AthenaEvent<any, any> {
  return {
    id: rxdbAthenaEvent.id,
    createdAt: rxdbAthenaEvent.createdAt,
    insertedAt: rxdbAthenaEvent.insertedAt,
    userId: rxdbAthenaEvent.userId,
    sessionId: rxdbAthenaEvent.sessionId,
    app: rxdbAthenaEvent.app,
    type: rxdbAthenaEvent.type,
    categoryData: rxdbAthenaEvent.categoryData,
    data: rxdbAthenaEvent.data,
  };
}
